<template>
    <div class="footer">
        <div class="footer__link-container">
            <Link
                v-for="(footerLink, index) in footerLinks" 
                :key="index" 
                :footer-link="footerLink"
            />
        </div>

        <div class="footer__btn-container">
            <slot />
        </div>
    </div>
</template>

<script>
import Link from "./link.vue";

const Footer = {
    components: { Link },
    props: {
        footerLinks: {
            type: Array,
            require: true
        }
    },
}

export default Footer;
</script>
<style scoped>
    
.footer {
  display: flex;
  margin-right: 70px;
  margin-top: 50px;
  width: calc(100% - 70px);
  justify-content: space-between;
  column-gap: 30px;
  margin-top: 33px;
  align-items: center;
}

.footer__link-container {
  flex-basis: 50%;
  display: block;
  gap: 10px;
  justify-content: flex-start;
  text-align: left;
}

.footer__btn-container {
  flex-basis: 50%;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}
</style>